document.addEventListener('DOMContentLoaded', function () {
    const container = document.querySelector('.watch-model-dropdown');
    const dropdowns = document.querySelectorAll('.watch-model-dropdown');

    if (container) { // Proceed only if page contains dropdown elements

        // Close all Opened Model Lists when clicked outside
        document.addEventListener('click', function (e) {
            dropdowns.forEach(function (dropdown) {
                if (!dropdown.contains(e.target)) {
                    const modelsList = dropdown.querySelector('.models-list');
                    modelsList.style.display = 'none';
                }
            });
        });

        // Open a Model list when clicked in search field
        document.addEventListener('focus', function (e) {
            const input = e.target;
            const dropdown = input.closest('.watch-model-dropdown');
            if (dropdown) {
                const modelsList = dropdown.querySelector('.models-list');
                modelsList.style.display = 'block';
            }
        }, true);

        // Search relevant Model when typed in field
        document.addEventListener('keyup', function (e) {
            const input = e.target;
            const filter = input.value.toUpperCase();
            const dropdown = input.closest('.watch-model-dropdown');
            const a = dropdown.querySelectorAll('a');
            a.forEach(function (anchor) {
                const txtValue = anchor.textContent || anchor.innerText;
                anchor.style.display = (txtValue.toUpperCase().indexOf(filter) > -1) ? '' : 'none';
            });
        });

        // When a model is selected from list
        document.querySelectorAll('.manual_path').forEach(function (manualPathElement) {
            manualPathElement.addEventListener('click', function (e) {
                e.preventDefault();
                const element = e.target;
                const dropdown = element.closest('.watch-model-dropdown');
                const selectedModel = element.textContent.trim();
                const selectedModelUrl = element.getAttribute('rel-path').trim();
                const input = dropdown.querySelector('input');

                input.value = selectedModel;

                const downloadCtaWrapper = dropdown.closest('.model-dropdown-wrapper');
                const downloadModel = downloadCtaWrapper.querySelector('.model-download');
                const downloadLink = downloadModel.querySelector('a');

                downloadLink.href = selectedModelUrl;
                downloadLink.classList.remove('disabled');
                downloadLink.classList.add('active');

                const modelsList = dropdown.querySelector('.models-list');
                modelsList.style.display = 'none';
            });
        });
    }
});